import Glide from '@glidejs/glide'


document.addEventListener("DOMContentLoaded", function (event) {
    //do work

    new Glide('.glide').mount()

});
